export default __webpack_public_path__ + "locales/pt-BR/EmptyTrashDialog.json?hash=f942991fc2110f0a827213398fb515aa";